import request from '@/utils/request'

// 工序排单列表
export function apiMesProcessSchedulingList (query) {
  return request({
    url: '/mes/mesProcessScheduling/list',
    method: 'post',
    data: query
  })
}

// 确认工序排单完工
export function apiMesProcessSchedulingComplete (id) {
  return request({
    url: `/mes/mesProcessScheduling/complete/${id}`,
    method: 'post'
  })
}

// 工序排单导出
export function apiMesProcessSchedulingExport (data) {
  return request({
    url: '/mes/mesProcessScheduling/export',
    method: 'post',
    data
  })
}

// 查询欧康排单打印详情
export function apiMesProcessSchedulingPrintDetail (ids) {
  return request({
    url: `/mes/mesProcessScheduling/print/${ids}`,
    method: 'get'
  })
}

// 查询工序排单可分配员工
export function apiMesProcessSchedulingEmployeeList (keyword) {
  return request({
    url: '/mes/mesProcessScheduling/employeeList',
    method: 'get',
    params: { keyword }
  })
}

// 保存工序排单行人员分配
export function apiMesProcessSchedulingAssignLines (data) {
  return request({
    url: '/mes/mesProcessScheduling/assignLines',
    method: 'post',
    data
  })
}

// 查询工单工作台日志
export function apiMesSelectMesWipLogList (query) {
  return request({
    url: '/mes/mesWipLog/selectMesWipCommonLogs',
    method: 'get',
    params: query
  })
}
